import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-view-01-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M2.5 3.75H17.5"
        [attr.stroke]="color() || '#2970FF'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M2.5 7.91602H17.5"
        [attr.stroke]="color() || '#2970FF'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M2.5 12.084H17.5"
        [attr.stroke]="color() || '#2970FF'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M2.5 16.25H17.5"
        [attr.stroke]="color() || '#2970FF'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class View01IconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
  override fill = input<string>('none');
}
